module.exports = __webpack_public_path__ + "static/media/successDeleteAssessment.ae085a51.svg";